import axios from "../axios-auth";
import orginal_axios from "axios";

export const brandService = {
  getBrandList,
  saveBrand,
  getBrandDetail,
  getBrandsByStatus,
  getAllBrand,
  saveBrandExcel,
  getBrandExcelTemplate,
  getBrandExcelExport
};

function getBrandList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/brands", { params });
}

function saveBrand(brand) {
  if (!brand.id) {
    // new brand
    return axios.post("/auth/brand", brand);
  } else {
    // edit
    return axios.put("/auth/brand", brand);
  }
}

function getBrandDetail(id) {
  return axios.get("/auth/brand/" + id);
}

function getBrandsByStatus(status) {
  return axios.get("/auth/brands-by-status/" + status);
}

function getAllBrand() {
  return axios.get("/auth/all-brand");
}

function saveBrandExcel(file) {
  return axios.post('/auth/brand-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getBrandExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/brand-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getBrandExcelExport(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/brand-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

